import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { FallbackLoginPage } from './components/FallbackLoginPage';
import './index.css';

// Unlinked emergency login route (see FallbackLoginPage.tsx). The /password/
// prefix itself isn't secret - the actual secret is the :code segment,
// which the page sends to the server for verification on load. Nothing
// sensitive is baked into this bundle; the real access control
// (LOGIN_FALLBACK_PATH_CODE and FALLBACK_LOGIN_PASSWORD) lives server-side.
const fallbackLoginMatch = window.location.pathname.match(/^\/password\/([^/]+)$/);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {fallbackLoginMatch ? <FallbackLoginPage code={decodeURIComponent(fallbackLoginMatch[1] ?? '')} /> : <App />}
  </React.StrictMode>
);
